import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { API_URL } from "../../../../constants/index";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { useNavigate } from "react-router-dom";

const GeneralMaster = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(updateNavbarHeading("General Master"));
  }, []);

  const [expenseData, setExpenseData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [respStatus, setRepStatus] = useState(0);
  const [apiStatus, SetApiStatus] = useState(undefined);

  const columns = {
    Code: { text: "Code", visible: true },
    Name: { text: "Name", visible: true },
    IsSystem: { text: "IsSystem", align: "center", visible: true },
  };

  const fetchGeneralMasterList = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}general-master`);
      SetApiStatus(response?.status);
      
      if (response.status === 200) {
        let expenseData = response?.data?.data;
        expenseData = expenseData?.map(item => ({
          ...item,
          IsSystem: item.IsSystem === 1 ? "Yes" : "No"
        }));
        setExpenseData(expenseData);
      } else {
        console.error(
          "Failed to fetch Leave. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Leave:", error);
    }
  };
  

  useEffect(() => {
    fetchGeneralMasterList();
  }, []);

  const handleAdd = () => {
    navigate(`/rujul/admin/general-master/add`)
  }

  const handleEdit = (id) => {
    navigate(`/rujul/admin/general-master/edit/${id.ID}`);
  };
  const handleView = (id) => {
    navigate(`/rujul/admin/general-master/view/${id.ID}`);
  };
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={expenseData}
              columns={columns}
              itemsPerPage={10}
              isSorting={true}
              showIcon2={true}
              showIcon3={true}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              searchTerm={searchTerm}
              responseStatus={respStatus}
              isActionRequired={true}
              setSearchTerm={setSearchTerm}
              isAddNewBtnRequired={true}
              handleIcon2={handleEdit}
              handleIcon3={handleView}
              handleAddNew={handleAdd}
              icons={{
                Icon2: <i className="bi bi-pencil-square"></i>,
                Icon2Text: "Edit",
                Icon3: <i className="bi bi-eye-fill"></i>,
                Icon3Text: "View",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default GeneralMaster;
